/* Pulizena (Sensa) — comportements de la page clonée, sans aucun script du concurrent */
(function () {
  var C = window.PZ_CFG || {};
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- saldi a fasi (stesse date della fonte) ---------- */
  var OFFER = '-60% + REGALI GRATIS';
  var BATCH = 'Scorte del raccolto 2025 · 89% già prenotato';
  var PHASES = [
    { id: 'halloween', skin: 'halloween', name: 'Saldi di Halloween', start: '2026-10-17T04:00:00Z', end: '2026-11-01T03:59:59Z', font: 'Chewy', look: 'ghosts', z1: 'Halloween', z2: 'Saldi',
      mq: ['Saldi di Halloween · 60% di sconto', 'Saldi di Halloween · Regali gratis in ogni confezione', 'Saldi di Halloween · Gli incantesimi scadono a mezzanotte'] },
    { id: 'earlybf', skin: 'bf', name: 'Black Friday anticipato', start: '2026-11-01T04:00:00Z', end: '2026-11-16T04:59:59Z',
      mq: ['Black Friday anticipato · 60% di sconto', 'Black Friday anticipato · Regali gratis in ogni confezione', 'Black Friday anticipato · Termina a mezzanotte'] },
    { id: 'bf', skin: 'bf', name: 'Black Friday', start: '2026-11-16T05:00:00Z', end: '2026-11-30T04:59:59Z',
      mq: ['Black Friday · 60% di sconto', 'Black Friday · Regali gratis in ogni confezione', 'Black Friday · Termina a mezzanotte'] },
    { id: 'cyber', skin: 'cyber', name: 'Cyber Monday', start: '2026-11-30T05:00:00Z', end: '2026-12-01T04:59:59Z', font: 'Space+Mono:wght@400;700',
      mq: ['Cyber Monday · 60% di sconto', 'Cyber Monday · Regali gratis in ogni confezione', 'Cyber Monday · Solo un giorno'] },
    { id: 'holiday', skin: 'holiday', name: 'Saldi di Natale', start: '2026-12-01T05:00:00Z', end: '2026-12-26T04:59:59Z', font: 'Playfair+Display:wght@600;700',
      cutoff: '2026-12-17T04:59:59Z', offerCut: 'Ordina entro il 16 dicembre per Natale',
      mq: ['Saldi di Natale · 60% di sconto', 'Saldi di Natale · Regali gratis in ogni confezione', 'Saldi di Natale · Ordina entro il 16 dicembre per Natale'],
      mq2: ['Saldi di Natale · 60% di sconto', 'Saldi di Natale · Regali gratis in ogni confezione', 'Saldi di Natale · Terminano a mezzanotte'] },
    { id: 'newyear', skin: 'newyear', name: 'Saldi di Capodanno', start: '2026-12-26T05:00:00Z', end: '2027-01-04T04:59:59Z', font: 'Playfair+Display:wght@600;700',
      mq: ['Saldi di Capodanno · 60% di sconto', 'Saldi di Capodanno · Regali gratis in ogni confezione', 'Saldi di Capodanno · Terminano a mezzanotte'] }
  ];
  var q = (location.search.match(/[?&]pz_preview=([a-z0-9]+)/) || [])[1];
  function active() {
    if (q === 'off') return null;
    var now = Date.now(), i;
    if (q) for (i = 0; i < PHASES.length; i++) if (PHASES[i].id === q) return PHASES[i];
    for (i = 0; i < PHASES.length; i++) if (now >= Date.parse(PHASES[i].start) && now <= Date.parse(PHASES[i].end)) return PHASES[i];
    return null;
  }
  function state(p) {
    var cut = p.cutoff && Date.now() < Date.parse(p.cutoff);
    return { offer: cut ? (p.offerCut || OFFER) : OFFER, mq: cut ? p.mq : (p.mq2 || p.mq) };
  }
  function parts(ms) { if (ms < 0) ms = 0; var s = Math.floor(ms / 1000); return { h: Math.floor(s / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 }; }
  function midnight() { var e = new Date(); e.setHours(23, 59, 59, 999); return e.getTime(); }
  function cells(cls) { var t = parts(midnight() - Date.now()); return '<span class="' + cls + '">' + pad(t.h) + '<small>h</small></span><span class="' + cls + '">' + pad(t.m) + '<small>m</small></span><span class="' + cls + '">' + pad(t.s) + '<small>s</small></span>'; }
  function boxes() { var t = parts(midnight() - Date.now()), L = ['Ore', 'Min', 'Sec'], v = [t.h, t.m, t.s], h = ''; for (var i = 0; i < 3; i++) { if (i) h += '<span class="pz-kk-zc">:</span>'; h += '<span class="pz-kk-zb"><b>' + pad(v[i]) + '</b><i>' + L[i] + '</i></span>'; } return h; }
  function deco(skin) {
    var h = '', i;
    if (skin === 'halloween') for (i = 0; i < 9; i++) { var c = ['#E2651D', '#B35621', '#D98B3F', '#8C3B1A'][i % 4]; h += '<i class="pz-kk-leaf" style="left:' + (4 + i * 11) + '%;background:' + c + ';animation-duration:' + (5 + (i % 4) * 1.3) + 's;animation-delay:-' + (i * 0.9) + 's;transform:scale(' + (0.8 + (i % 3) * 0.25) + ')"></i>'; }
    if (skin === 'holiday') for (i = 0; i < 14; i++) h += '<i class="pz-kk-flake" style="left:' + (2 + i * 7) + '%;animation-duration:' + (6 + (i % 5)) + 's;animation-delay:-' + (i * 0.7) + 's;transform:scale(' + (0.6 + (i % 3) * 0.3) + ')"></i>';
    if (skin === 'newyear') { var pos = [[4, 18], [9, 66], [16, 38], [84, 30], [91, 68], [96, 22], [30, 8], [70, 8], [50, 90]]; for (i = 0; i < pos.length; i++) h += '<i class="pz-kk-spark" style="left:' + pos[i][0] + '%;top:' + pos[i][1] + '%;animation-delay:-' + (i * 0.4) + 's"></i>'; }
    return h;
  }
  function font(p) { if (!p.font || document.getElementById('pz-font-' + p.id)) return; var l = document.createElement('link'); l.id = 'pz-font-' + p.id; l.rel = 'stylesheet'; l.href = 'https://fonts.googleapis.com/css2?family=' + p.font + '&display=swap'; document.head.appendChild(l); }
  var timers = []; function onTick(f) { timers.push(f); f(); }
  setInterval(function () { for (var i = 0; i < timers.length; i++) timers[i](); }, 1000);

  function initSale() {
    var p = active();
    var bar = document.getElementById('kk-sale-bar'), card = document.getElementById('kk-sale-urgency');
    var title = document.getElementById('pz-block-title');
    if (!p) {
      if (bar) bar.hidden = true;
      if (card) card.hidden = true;
      if (title) title.textContent = 'OFFERTA SPECIALE';
      $$('.pz-kk-marq__item--sale').forEach(function (e) { e.remove(); });
      return;
    }
    font(p);
    var st = state(p);
    if (title) title.textContent = p.name.toUpperCase();
    document.documentElement.classList.add('pz-sale-on');
    if (bar) {
      bar.className = 'pz-kk-bar pz-s-' + p.skin; bar.hidden = false;
      bar.innerHTML = deco(p.skin) + '<span class="pz-kk-bar__l1"><span class="pz-kk-name">' + p.name + '</span> <span class="pz-kk-bar__sep">·</span> <span class="pz-kk-bar__offer">' + st.offer + '</span></span><span class="pz-kk-bar__cd"><span>Termina tra:</span><span class="pz-kk-bar__cells"></span></span>';
      var c = $('.pz-kk-bar__cells', bar);
      onTick(function () { c.innerHTML = cells('pz-kk-cell'); });
    }
    var k = 0;
    $$('.pz-kk-marq__item--sale').forEach(function (e) { e.textContent = st.mq[k % st.mq.length]; k++; });
    if (card) {
      card.hidden = false;
      if (p.look === 'ghosts') {
        card.className = 'pz-kk-u pz-kk-u--z pz-s-' + p.skin;
        card.innerHTML = deco(p.skin) + '<div class="pz-kk-z__img"><i></i></div><div class="pz-kk-z__txt"><span class="pz-kk-z__ends">Sta per finire</span><span class="pz-kk-z__hw">' + p.z1 + '</span><span class="pz-kk-z__ribbon"><span class="pz-kk-z__offer"></span></span><span class="pz-kk-z__sale">' + p.z2 + '</span><div class="pz-kk-z__cd"></div><span class="pz-kk-z__bar"><b></b></span><div class="pz-kk-z__stock"></div></div>';
        var zo = $('.pz-kk-z__offer', card), zc = $('.pz-kk-z__cd', card), zs = $('.pz-kk-z__stock', card), zb = $('.pz-kk-z__bar b', card), grown = false;
        var grow = function () { if (grown) return; grown = true; setTimeout(function () { zb.style.width = '89%'; }, 60); };
        if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { grow(); io.disconnect(); } }, { threshold: 0.35 }); io.observe(card); } else grow();
        zs.innerHTML = 'Scorte del raccolto 2025 · <strong>89% già prenotato</strong>';
        onTick(function () { zo.textContent = st.offer; zc.innerHTML = boxes(); });
      } else {
        card.className = 'pz-kk-u pz-s-' + p.skin;
        card.removeAttribute('style');
        card.innerHTML = deco(p.skin) + '<span class="pz-kk-name">' + p.name + '</span><div class="pz-kk-u__row"><span class="pz-kk-u__offer"></span><span class="pz-kk-u__cd"><span class="pz-kk-u__cdl">Termina tra:</span><span class="pz-kk-u__cells"></span></span></div><span class="pz-kk-u__bar"><b style="width:89%"></b></span><div class="pz-kk-u__bt"><i class="pz-kk-u__dot"></i><span class="pz-kk-u__btt">Scorte del raccolto 2025 · <strong>89% già prenotato</strong></span></div>';
        var of = $('.pz-kk-u__offer', card), ce = $('.pz-kk-u__cells', card);
        onTick(function () { of.textContent = st.offer; ce.innerHTML = cells('pz-kk-cell'); });
      }
    }
  }
  function initScarce() {
    var el = document.getElementById('kk-scarce-count'); if (!el) return;
    onTick(function () { var t = parts(midnight() - Date.now()); el.textContent = pad(t.h) + ':' + pad(t.m) + ':' + pad(t.s); });
  }

  /* ---------- galleria: slider mobile + miniature ---------- */
  function initGallery() {
    var main = $('.pz-product__media-list'), thumbs = $('.pz-thumbnail-list');
    if (!main) return;
    var slides = $$('.pz-product__media-item', main);
    var th = thumbs ? $$('.pz-thumbnail-list__item', thumbs) : [];
    var cur = 0;
    var counter = $('.pz-slider-counter--current');
    function setActive(i, scroll) {
      cur = Math.max(0, Math.min(slides.length - 1, i));
      slides.forEach(function (s, k) { s.classList.toggle('pz-is-active', k === cur); });
      th.forEach(function (t, k) { var b = $('button', t); if (b) { if (k === cur) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); } });
      if (counter) counter.textContent = cur + 1;
      if (scroll && main.scrollWidth > main.clientWidth + 2) main.scrollTo({ left: slides[cur].offsetLeft - main.offsetLeft, behavior: 'smooth' });
      var t = th[cur];
      if (t && thumbs.scrollWidth > thumbs.clientWidth + 2) {
        var l = t.offsetLeft - thumbs.offsetLeft, w = t.offsetWidth;
        if (l < thumbs.scrollLeft || l + w > thumbs.scrollLeft + thumbs.clientWidth) thumbs.scrollTo({ left: l - (thumbs.clientWidth - w) / 2, behavior: 'smooth' });
      }
      updThumbArrows();
    }
    th.forEach(function (t, k) { var b = $('button', t); if (b) b.addEventListener('click', function () { setActive(k, true); }); });
    var to;
    main.addEventListener('scroll', function () {
      clearTimeout(to);
      to = setTimeout(function () { if (main.scrollWidth <= main.clientWidth + 2) return; var i = Math.round(main.scrollLeft / main.clientWidth); if (i !== cur) setActive(i, false); }, 80);
    }, { passive: true });
    var tsl = thumbs && thumbs.closest('pz-slider-component');
    var tprev = tsl && $('.pz-slider-button--prev', tsl), tnext = tsl && $('.pz-slider-button--next', tsl);
    function updThumbArrows() {
      if (!thumbs) return;
      var max = thumbs.scrollWidth - thumbs.clientWidth;
      if (tprev) { if (thumbs.scrollLeft <= 2) tprev.setAttribute('disabled', 'disabled'); else tprev.removeAttribute('disabled'); }
      if (tnext) { if (thumbs.scrollLeft >= max - 2) tnext.setAttribute('disabled', 'disabled'); else tnext.removeAttribute('disabled'); }
    }
    if (thumbs) {
      thumbs.addEventListener('scroll', function () { clearTimeout(thumbs._t); thumbs._t = setTimeout(updThumbArrows, 60); }, { passive: true });
      var stepW = function () { var it = th[0]; return it ? (it.getBoundingClientRect().width + (parseFloat(getComputedStyle(it).marginRight) || 0) + (parseFloat(getComputedStyle(thumbs).columnGap) || 0)) * 3 : thumbs.clientWidth; };
      if (tprev) tprev.addEventListener('click', function () { thumbs.scrollBy({ left: -stepW(), behavior: 'smooth' }); });
      if (tnext) tnext.addEventListener('click', function () { thumbs.scrollBy({ left: stepW(), behavior: 'smooth' }); });
      window.addEventListener('resize', updThumbArrows);
    }
    var msl = main.closest('pz-slider-component');
    if (msl) {
      var mp = $('.pz-slider-button--prev', msl), mn = $('.pz-slider-button--next', msl);
      if (mp) mp.addEventListener('click', function () { setActive(cur - 1, true); });
      if (mn) mn.addEventListener('click', function () { setActive(cur + 1, true); });
    }
    setActive(0, false);
  }

  /* ---------- offerta (paliers) + regali progressivi ---------- */
  var tier = 3;
  var TIERS = { 1: { q: 2, code: C.code2, price: '24,95 €', save: 17 }, 2: { q: 4, code: C.code4, price: '18,73 €', save: 38 }, 3: { q: 8, code: C.code8, price: '15,62 €', save: 48 } };
  function selectTier(n) {
    tier = n;
    $$('.pz-kaching-bundles__bar[data-pz-tier]').forEach(function (b) {
      var on = +b.getAttribute('data-pz-tier') === n;
      b.classList.toggle('pz-kaching-bundles__bar--selected', on);
      var i = $('input', b); if (i) i.checked = on;
    });
    var t = TIERS[n];
    var now = document.getElementById('kk-now'), save = document.getElementById('kk-save');
    if (now) now.textContent = t.price + ' cad.';
    if (save) save.textContent = 'Risparmi ' + t.save + '%';
    $$('[data-pz-unlock]').forEach(function (g) {
      var open = +g.getAttribute('data-pz-unlock') <= n;
      g.classList.toggle('pz-kaching-bundles__progressive-gifts__gift--locked', !open);
      if (!open) { g.setAttribute('role', 'button'); g.setAttribute('tabindex', '0'); } else { g.removeAttribute('role'); g.removeAttribute('tabindex'); }
      $('.pz-gift-open', g).hidden = !open;
      $('.pz-gift-locked', g).hidden = open;
    });
  }
  function initOffer() {
    $$('.pz-kaching-bundles__bar[data-pz-tier]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); selectTier(+b.getAttribute('data-pz-tier')); });
    });
    $$('[data-pz-unlock]').forEach(function (g) {
      g.addEventListener('click', function () { var u = +g.getAttribute('data-pz-unlock'); if (u > tier) selectTier(u); });
    });
    var m = /[?&]pack=(\d)/.exec(location.search);
    selectTier(m && TIERS[+m[1]] ? +m[1] : 3);
  }

  /* ---------- aggiunta al carrello rapida (zosAjoutRapide) ---------- */
  var cartCache = null;
  function refreshCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { cartCache = c; return c; }).catch(function () { return null; }); }
  function busy(btn, on) { if (!btn) return; btn.style.pointerEvents = on ? 'none' : ''; btn.style.opacity = on ? '.7' : ''; btn.setAttribute('aria-busy', on ? 'true' : 'false'); }
  function addToCart(btn) {
    var t = TIERS[tier];
    var items = [{ id: C.variant, quantity: t.q }];
    busy(btn, true);
    refreshCart().then(function (cart) {
      var have = {};
      ((cart && cart.items) || []).forEach(function (i) { have[i.variant_id] = 1; });
      (C.gifts || []).forEach(function (g) { if (g.unlock <= tier && !have[g.id]) items.push({ id: g.id, quantity: 1 }); });
    }).catch(function () {}).then(function () {
      if (window.zosAjoutRapide) return window.zosAjoutRapide(items, t.code);
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: t.code }) })
        .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }); })
        .then(function () { location.href = '/cart'; });
    }).then(function () { busy(btn, false); setTimeout(refreshCart, 400); }, function () { busy(btn, false); location.href = '/cart'; });
  }
  function initAtc() {
    refreshCart();
    document.addEventListener('cart:updated', refreshCart);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCart(); });
    setInterval(function () { if (document.querySelector('cart-drawer.active')) refreshCart(); }, 4000);
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-pz-atc]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      addToCart(btn);
    }, true);
  }

  /* ---------- link interni ---------- */
  function initLinks() {
    var stars = document.getElementById('kk-stars-link');
    if (stars) stars.addEventListener('click', function (e) { var t = document.getElementById('kk-reviews'); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
    $$('.pz-root a[href="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var t = $('.pz-kaching-bundles') || $('.pz-product__info-container');
        if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
      });
    });
  }

  /* ---------- recensioni ---------- */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function initReviews() {
    var list = document.getElementById('pz-rv-list'), pagWrap = document.getElementById('pz-rv-pag');
    var D = window.PZ_REV; if (!list || !D) return;
    var all = D.REV.map(function (r, i) { r.i = i; return r; }), rows = all.slice(), page = 1, per = 5;
    var BADGE = { shop: 'Recensione scritta nell’app Shop', invite: 'Raccolta tramite invito del negozio' };
    function item(r) {
      var body = '<p>' + esc(r.b) + '</p>';
      if (r.p) body += '<div class="pz-rv-photo"><a href="' + r.p + '" target="_blank" rel="noopener"><img src="' + r.p + '" alt="Foto della recensione di ' + esc(r.n) + '" loading="lazy" width="96" height="128"></a></div>';
      var h = D.tpl.replace(/@@N@@/g, esc(r.n)).replace('@@I@@', esc(r.n.charAt(0).toUpperCase())).replace('@@D@@', r.d).replace('@@S@@', BADGE[r.s] || BADGE.shop);
      if (r.t) body = '<b class="pz-rv-title">' + esc(r.t) + '</b>' + body;
      return h.replace('@@B@@', body);
    }
    function pages() { return Math.max(1, Math.ceil(rows.length / per)); }
    function render() {
      list.innerHTML = rows.slice((page - 1) * per, page * per).map(item).join('');
      var n = pages(), h = '';
      var nav = pagWrap.querySelector('nav');
      if (!nav) return;
      var btns = $$('button', nav);
      var tplPrev = btns[0], tplAct = nav.querySelector('.pz-jm-pagination-controls__button--active'), tplPg = nav.querySelector('.pz-jm-pagination-controls__button--page:not(.pz-jm-pagination-controls__button--active)'), tplNext = btns[btns.length - 1];
      if (!pagWrap._t) pagWrap._t = { prev: tplPrev.outerHTML, act: tplAct.outerHTML, pg: tplPg.outerHTML, next: tplNext.outerHTML, wrap: nav.firstElementChild.cloneNode(false).outerHTML };
      var T = pagWrap._t;
      function pb(k) { var s = (k === page ? T.act : T.pg); return s.replace(/>\d+</, '>' + k + '<').replace(/aria-label="[^"]*"/, 'aria-label="Vai alla pagina ' + k + '"').replace('<button', '<button data-pz-pg="' + k + '"'); }
      var seq = [];
      if (n <= 6) for (var k = 1; k <= n; k++) seq.push(k);
      else { seq = page <= 3 ? [1, 2, 3, 4, '…', n] : (page >= n - 2 ? [1, '…', n - 3, n - 2, n - 1, n] : [1, '…', page - 1, page, page + 1, '…', n]); }
      if (n <= 6 && n > 5) seq = [1, 2, 3, 4, '…', n];
      if (n <= 6 && n > 5 && page > 3) seq = [1, '…', 3, 4, 5, 6];
      seq.forEach(function (k) { h += (k === '…') ? '<span class="pz-jm-text pz-rv-ell">…</span>' : pb(k); });
      var prev = T.prev.replace('<button', '<button data-pz-pg="' + (page - 1) + '"');
      var next = T.next.replace('<button', '<button data-pz-pg="' + (page + 1) + '"');
      prev = page <= 1 ? prev : prev.replace(/\sdisabled(="[^"]*")?/, '').replace(' pz-jm-button--disabled', '');
      next = page >= n ? next.replace('<button', '<button disabled').replace('pz-jm-button--secondary', 'pz-jm-button--secondary pz-jm-button--disabled') : next.replace(/\sdisabled(="[^"]*")?/, '').replace(' pz-jm-button--disabled', '');
      nav.innerHTML = T.wrap.replace('></div>', '>' + prev + h + next + '</div>');
    }
    pagWrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pz-pg]'); if (!b || b.disabled) return;
      var k = +b.getAttribute('data-pz-pg'); if (k < 1 || k > pages()) return;
      page = k; render();
      var top = document.getElementById('kk-reviews'); if (top) window.scrollTo({ top: list.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
    });
    var sel = $('#kk-reviews select');
    if (sel) {
      sel.value = 'created_at';
      sel.addEventListener('change', function () {
        var v = sel.value;
        rows = all.slice();
        if (v === 'with_pictures') rows = all.filter(function (r) { return r.p; });
        else if (v === 'pictures_first') rows.sort(function (a, b) { return (b.p ? 1 : 0) - (a.p ? 1 : 0) || a.i - b.i; });
        page = 1; render();
      });
    }
    var write = $('#kk-reviews [data-testid="write-review-button"]');
    if (write) write.addEventListener('click', function () { location.href = 'mailto:' + (C.email || '') + '?subject=' + encodeURIComponent('Recensione Pulizena'); });
    var filt = $('#kk-reviews .pz-jm-custom-answer-filter');
    if (filt) filt.addEventListener('click', function () { if (sel) { sel.focus(); if (sel.showPicker) try { sel.showPicker(); } catch (e) {} } });
    render();
  }

  function init() {
    initSale(); initScarce(); initGallery(); initOffer(); initAtc(); initLinks(); initReviews();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
